import React, { useState } from "react";
import Input from "../../components/Input";
import { FaCheck } from "react-icons/fa";
import { validatePassword, validateConfirmPassword } from "../../util/validate";
import styles from "./styles/Settings.module.css";
import { setLoadingBar } from "../../ducks/siteData";
import { api } from "../../services/api";
import { errorCodes } from "@chesshotel/constants";
import useTranslation from "next-translate/useTranslation";

export default function Password() {
  const { t } = useTranslation("common");
  const { t: settingsT } = useTranslation("auth");

  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState(null);
  const [passwordUpdated, setPasswordUpdated] = useState(false);

  function updatePassword() {
    const passwordErr = validatePassword(password);
    const confirmErr = validateConfirmPassword(password, confirmPassword);

    setPasswordError(passwordErr);
    setConfirmPasswordError(confirmErr);

    if (!passwordErr && !confirmErr) {
      setLoadingBar(true);
      api
        .post("/password/update", { password })
        .then((response) => {
          console.log("status: ", response.status);
          setPassword("");
          setConfirmPassword("");
          setPasswordUpdated(true);
        })
        .catch((err) => {
          console.log("err", err);
          setPasswordError(errorCodes.ERROR_GENERAL);
        })
        .then(() => {
          setLoadingBar(false);
        });
    }
  }

  return (
    <div className={styles.body}>
      <div className={styles.title}>
        {settingsT("Update password")}{" "}
        {passwordUpdated && (
          <div className={styles.doneCheck}>
            <FaCheck />
          </div>
        )}
      </div>
      <div className={styles.form}>
        <Input
          className={styles.margin}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          label={t("Password")}
          type="password"
          errorCode={passwordError}
        />

        <Input
          className={styles.margin}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          label={t("Password again")}
          type="password"
          errorCode={confirmPasswordError}
        />

        <button
          className={`btn btn-base btn-red ${
            passwordUpdated ? "btn-disabled" : ""
          }`}
          onClick={() => updatePassword()}
          disabled={passwordUpdated}
        >
          {passwordUpdated ? t("Done") : t("Save")}
        </button>
      </div>
    </div>
  );
}
